import React, { useState } from "react"
import SlickSlider from "react-slick"
import ReactMarkdown from "react-markdown"
import { ICharacter, IMediaAsset } from "../../../gatsby-graphql"
import { Heading } from "../../ui"
import { SectionProps } from "../section-loader"
import {
  CharactersWrapper,
  ContentWrapper,
  Description,
  Details,
  Feature,
  FeatureDescription,
  FeatureImage,
  HeadingWrapper,
  Image,
  Images,
  SectionWrapper,
  Skin,
  Slide,
  SlideNumber,
  Thumbnail,
  Thumbnails,
} from "./characters-elements"

interface CharactersProps extends SectionProps {
  data: {
    heading?: string
    description?: string
    characters?: ICharacter[]
    background?: IMediaAsset
  }
}

const Characters = ({ data, locale }: CharactersProps) => {
  if (!data || !data.characters || data.characters.length === 0) {
    return <></>
  }
  const [selectedCharacter, setSelectedCharacter] = useState<ICharacter>(
    data.characters[0]
  )
  const [selectedImageIdx, setSelectedImageIdx] = useState<number>(0)
  const [currentSlideIdx, setCurrentSlideIdx] = useState<number>(0)

  const changeCharacter = (character: ICharacter) => {
    setSelectedImageIdx(0)
    setSelectedCharacter(character)
  }

  return (
    <SectionWrapper bgImg={data.background?.url as string}>
      <ContentWrapper>
        <HeadingWrapper>
          <Heading.H2>{data.heading}</Heading.H2>
          {data.description && <Description>{data.description}</Description>}
        </HeadingWrapper>
        <CharactersWrapper>
          <Details>
            <SlideNumber>{currentSlideIdx + 1}/4</SlideNumber>
            <Heading.H2 textTransform="uppercase">
              {selectedCharacter.name}
            </Heading.H2>
            <SlickSlider
              arrows={true}
              dots={false}
              fade={true}
              autoplay={false}
              beforeChange={(oldIdx, newIdx) => setCurrentSlideIdx(newIdx)}
            >
              <Slide>
                <ReactMarkdown>
                  {selectedCharacter.description as string}
                </ReactMarkdown>
              </Slide>
              <Slide>
                {selectedCharacter.features &&
                  selectedCharacter.features.length > 0 &&
                  selectedCharacter.features.map((feature, index) => (
                    <Feature key={index}>
                      <FeatureImage src={feature?.image?.url as string} alt={feature?.image?.name ? feature?.image?.name : ""}/>
                      <FeatureDescription>
                        <Heading.H6>{feature?.name}</Heading.H6>
                        <ReactMarkdown>
                          {feature?.description as string}
                        </ReactMarkdown>
                      </FeatureDescription>
                    </Feature>
                  ))}
              </Slide>
              <Slide>
                <ReactMarkdown>
                  {selectedCharacter.details as string}
                </ReactMarkdown>
              </Slide>
              <Slide>
                {selectedCharacter.images?.map((image, idx) => (
                  <Skin
                    onClick={() => setSelectedImageIdx(idx)}
                    selected={idx === selectedImageIdx}
                    key={idx}
                  >
                    {image?.caption}
                  </Skin>
                ))}
              </Slide>
            </SlickSlider>
          </Details>
          <Images>
            <Image>
              {selectedCharacter.images &&
                selectedCharacter.images[selectedImageIdx] && (
                  <img
                    src={
                      selectedCharacter.images[selectedImageIdx]?.url as string
                    }
                  /> // TODO: GatsbyImage
                )}
            </Image>
            <Thumbnails>
              {data.characters.map((character, index) => (
                <Thumbnail
                  onClick={() => changeCharacter(character)}
                  selected={character === selectedCharacter}
                  key={index}
                >
                  <img src={character.thumbnail?.url as string} />
                </Thumbnail>
              ))}
            </Thumbnails>
          </Images>
        </CharactersWrapper>
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default Characters
